import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import CoreApiLogList from 'containers/pages/coreApiLog/List'

const CoreApiLog = ({ currentUser, location }) => {
  if (currentUser.permissions && currentUser.permissions.indexOf('manage-corelogapi-read') > -1) {
    return <CoreApiLogList location={location} />
  }
  return <ForbiddenPage />
}

CoreApiLog.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
}

export default CoreApiLog
